import { render, staticRenderFns } from "./OptionDropdownConsolidarFacturacion.vue?vue&type=template&id=245c5ff2&"
import script from "./OptionDropdownConsolidarFacturacion.vue?vue&type=script&lang=js&"
export * from "./OptionDropdownConsolidarFacturacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports